'use client'

import React from 'react'

export default function useAutoScrollToTop(deps: React.DependencyList = []) {
    // Since we're sending dependinceis further on we don't need to check them

    return React.useEffect(() => {
        window.scrollTo(0, 0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)
}
